<template>
  <dl class="invoice">
     <dt class="title">发票详情</dt>
      <dd class="item" v-for="item in detailData">
        <span class="name">{{item.attrName}}</span>
        <div class="img-box" v-if="[5, 6].indexOf(item.fieldType) > -1">
          <span class="img" v-for="url in strToArr(item.value4Show)" @click="openLightbox(url)">
            <img :src="url" height="40" width="40">
          </span>
        </div>
        <span class="text" v-else-if="[0].indexOf(item.fieldType) > -1 && item.multiValue">
          <template v-if="!item.multiValue.length">
            {{'空'}}
          </template>
          <p v-else v-for="(n,index) in item.multiValue" style="display:inline-block">
            <a @click="openDetail(n.popModel, n.id)">{{n.value4Show}}</a>
            <span v-if="index !== item.multiValue.length-1 && n.value4Show">、</span>
          </p>
        </span>
        <template v-else-if="item.fieldType===8">
          <!-- 附件信息 -->
          <attachment-preview v-if="item.value4Show" :data="item.value4Show"></attachment-preview>
        </template>
        <span class="text" v-else>
          <template v-if="!item.popModel">
            {{item.value4Show || '空'}}
          </template>
          <a v-else @click="openDetail(item.popModel, item.id)">{{item.value4Show}}</a>
        </span>
      </dd>

      <dt class="title red-title" v-if="relativeRedInvoices.length !== 0">红冲发票</dt>
      <div v-for="item in relativeRedInvoices" class="red-detail">
        <dd class="item">
          <span class="name">红冲发票编号</span>
          <a @click="openRedDetail(item.popModel, item.invoiceId)">{{item.sheetNo}}</a>
        </dd>
        <dd class="item">
          <span class="name">申请人</span>
          <span class="text">{{item.userName}}</span>
        </dd>
        <dd class="item">
          <span class="name">红冲开票金额</span>
          <span class="text text-red">{{item.totalMoney}}</span>
        </dd>
        <dd class="item">
          <span class="name">开票日期</span>
          <span class="text">{{item.invoiceDate}}</span>
        </dd>
        <dd class="item">
          <span class="name">备注</span>
          <span class="text">{{item.memo}}</span>
        </dd>
      </div>
  </dl>
</template>

<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'
import attachmentPreview from 'components/common/attachment-preview'
export default {
  props: {
    id: {
      required: true
    }
  },

  data () {
    return {
      detailData: '',
      relativeRedInvoices: ''
    }
  },

  mounted () {
    let url = '/invoice/detailAjax.html'
    api.post(url, {id: this.id}, (data) => {
      this.detailData = data.result
      this.relativeRedInvoices = data.relativeRedInvoices
    })
  },

  methods: {
    strToArr (str) {
      return window.utils.json(str)
    },

    openLightbox (url) {
      lightBox(url)
    },

    openDetail (type, id) {
      this.$emit('openDetail', type, id)
    },
    openRedDetail (type, id) {
      this.$emit('openDetail', type, id)
    }
  },
  components: {
    attachmentPreview
  }
}

</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  // 发票详情
  .invoice {
    .title {
      height: 24px;
      line-height: 24px;
      border-left: 4px solid @light-blue;
      color: @light-blue;
      padding-left: 12px;
      font-size: 15px;
    }
    .red-title {
      color: @bg-red;
      border-left: 4px solid @bg-red;
      margin-top: 30px;
    }
    .red-detail {
      border-bottom: 1px solid #dedede;
      padding-bottom: 4px;
    }
    .item {
      line-height: 1.5;
      margin-top: 10px;
      font-size: 13px;
      position: relative;
      padding-left: 110px;
      min-height: 19px;
      .name {
        color: @light-gray;
        display: inline-block;
        width: 90px;
        position: absolute;
        left: 15px;
        top: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .text-red {
        color: @bg-red;
      }
      .img-box {
        display: inline-block;
        vertical-align: top;
      }
    }
  }
</style>
<style>
  /* 层叠子组件样式*/
  .invoice .item .file-content .file-info {
    margin: 0;
    padding: 0;
    border-top: none;
  }
  .invoice .item .file-content .file-info .label {
    display: none;
  }
  .invoice .item ba.file-content .file-info .file-name {
    min-width: 220px;
  }
</style>




// WEBPACK FOOTER //
// invoice-basic-item.vue?1dea35af